import { FormState } from '../createAccountTypes';
import { validatePassword } from './passwordValidation';

const EMAIL_REGEX = /^(?=.{1,64}@)[a-zA-Z0-9](([.-]?\w+)*)@{1}[a-zA-Z](([.-]?\w+)*[a-zA-Z])(\.[A-Za-z]{2,})$/;

export const isValidEmail = (email: string): boolean => {
  // temporary check for .con as invalid
  if (email.endsWith('.con')) {
    return false;
  }
  return EMAIL_REGEX.test(email);
};

export function returnOnlyNumbers(string: string): string {
  return string && string.replace(/\D/g, '');
}

export function getPhoneNumberPrefixFromMask(maskString: string) {
  if (!maskString) {
    return '';
  }
  return maskString.split(' ')[0];
}

export function validateAccountForm(formState: FormState) {
  const {
    email, password,
  } = formState;

  if (!isValidEmail(email)) {
    return false;
  }
  if (!validatePassword(password)) {
    return false;
  }

  return true;
}
